export { default as Routes } from 'routes/Routes';



// WEBPACK FOOTER //
// src/routes/index.js